import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { take, withLatestFrom } from 'rxjs/operators';

import { FEATURES, VehicleCoveragesFacade } from '@amfam/policy/vehicle-coverages/data-access';
import { BrandSelectors } from '@amfam/shared/utility/brand';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { CopyService } from '@amfam/shared/utility/shared-services';
import { LoadingSpinnerService } from '@amfam/ui-kit';

import * as VehicleInfoActions from '../+state/add-vehicle-feature.actions';
import { AddVehicleFeatureService } from '../services/add-vehicle-feature.service';

@Component({
  selector: 'ds-uw-questions',
  templateUrl: './uw-questions.component.html',
  styleUrls: ['./uw-questions.component.scss'],
  standalone: false
})
export class UwQuestionsComponent implements OnInit, OnDestroy {
  @Output() cancelEvent = new EventEmitter<boolean>();

  public isPartner$ = this.store.select(BrandSelectors.selectIsPartner);
  questions = [];

  constructor(
    private copyService: CopyService,
    private store: Store,
    private spinnerService: LoadingSpinnerService,
    private addVehicleFeatureService: AddVehicleFeatureService,
    private facade: VehicleCoveragesFacade
  ) {}

  ngOnInit(): void {
    this.spinnerService.stop();
    this.questions = this.copyService.getCopy('policy.underWritingFinalScreenLists');
  }
  ngOnDestroy(): void {
    this.spinnerService.stop();
  }
  goBackOneStep() {
    this.store.dispatch(fromRouterActions.Back());
  }
  noneApplyClicked() {
    this.addVehicleFeatureService
      .hasUWHardStop()
      .pipe(withLatestFrom(this.isPartner$), take(1))
      .subscribe(([isHardStop, isPartner]) => {
        if (isHardStop) {
          this.clickedOnYes();
        } else {
          this.spinnerService.start({
            blockActions: true,
            isProgressBar: true,
            secondaryMessage: this.copyService.getCopy('policy.quoteCalculatingLoadingSpinnerText')
          });
          this.store.dispatch(
            VehicleInfoActions.addVehicleSendAnalytics({
              payload: { pageAnalyticName: 'QuoteCalculating' }
            })
          );
          if (isPartner) this.facade.loadInitialRate(FEATURES.ADD);
          else this.store.dispatch(VehicleInfoActions.addVehicleRate());
        }
      });
  }
  clickedOnYes() {
    this.spinnerService.start({
      blockActions: true
    });
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['policies/add-vehicle/agent-help']
      })
    );
  }
}
